import React, { useEffect } from 'react';
import { Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  
  // Inject Fogyasztó Barát HUD (floating badge)
  useEffect(() => {
    if (document.getElementById("fbarat") === null) {
      const hst = document.createElement("script");
      hst.src = "https://admin.fogyasztobarat.hu/h-api.js";
      hst.type = "text/javascript";
      hst.setAttribute("data-id", "63V3CLSM");
      hst.setAttribute("id", "fbarat");
      document.body.appendChild(hst);
    }
  }, []);

  return (
    <footer className="bg-background text-foreground py-24 px-6 border-t border-border/40">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-4 gap-16 mb-16">
          
          {/* Column 1: Céginformációk */}
          <div className="md:col-span-1">
            <h4 className="text-xs uppercase tracking-widest font-bold mb-8 text-accent">
              Impresszum
            </h4>
            <ul className="space-y-4 text-sm font-light text-muted-foreground">
              <li className="flex flex-col gap-1">
                <span className="text-[10px] uppercase tracking-wider opacity-60">Cégnév</span>
                <span className="text-foreground">A KONYHÁD Kft.</span>
              </li>
              <li className="flex flex-col gap-1">
                <span className="text-[10px] uppercase tracking-wider opacity-60">Székhely</span>
                <span className="text-foreground">3557 Bükkszentkereszt, Táncsics utca 54.</span>
              </li>
              <li className="flex flex-col gap-1">
                <span className="text-[10px] uppercase tracking-wider opacity-60">Cégjegyzékszám</span>
                <span className="text-foreground">05-09-035801</span>
              </li>
              <li className="flex flex-col gap-1">
                <span className="text-[10px] uppercase tracking-wider opacity-60">Adószám</span>
                <span className="text-foreground">32048285-2-05</span>
              </li>
            </ul>
          </div>

          {/* Column 2: Elérhetőségek */}
          <div className="md:col-span-1">
            <h4 className="text-xs uppercase tracking-widest font-bold mb-8 text-accent">
              Elérhetőségek
            </h4>
            <ul className="space-y-4 text-sm font-light text-muted-foreground">
              <li className="flex flex-col gap-1">
                <span className="text-[10px] uppercase tracking-wider opacity-60">Cím</span>
                <span className="text-foreground">3525 Miskolc, Kis-Hunyad utca 52.</span>
              </li>
              <li className="flex flex-col gap-1">
                <span className="text-[10px] uppercase tracking-wider opacity-60">E-mail cím</span>
                <a href="mailto:info@akonyhad.hu" className="text-foreground hover:text-accent transition-colors">info@akonyhad.hu</a>
              </li>
              <li className="flex flex-col gap-1">
                <span className="text-[10px] uppercase tracking-wider opacity-60">Telefonszám</span>
                <a href="tel:+36705557794" className="text-foreground hover:text-accent transition-colors">+36 70 555 7794</a>
                <a href="tel:+36705858222" className="text-foreground hover:text-accent transition-colors">+36 70 585 8222</a>
              </li>
            </ul>
          </div>

          {/* Column 3: Tárhely & Jogi */}
          <div className="md:col-span-1">
            <h4 className="text-xs uppercase tracking-widest font-bold mb-8 text-accent">
              Tárhelyszolgáltató
            </h4>
            <ul className="space-y-4 text-sm font-light text-muted-foreground mb-8">
              <li className="flex flex-col gap-1">
                <span className="text-[10px] uppercase tracking-wider opacity-60">Név</span>
                <span className="text-foreground">Emergent Labs Inc.</span>
              </li>
              <li className="flex flex-col gap-1">
                <span className="text-[10px] uppercase tracking-wider opacity-60">Weboldal</span>
                <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-foreground hover:text-accent transition-colors">https://emergent.sh</a>
              </li>
            </ul>
          </div>

          {/* Column 4: Jogi információk */}
          <div className="md:col-span-1">
            <h4 className="text-xs uppercase tracking-widest font-bold mb-8 text-accent">
              Jogi Információk
            </h4>
            <ul className="space-y-4 text-sm font-light text-muted-foreground">
              <li>
                <Link to="/aszf" className="text-foreground hover:text-accent transition-colors underline underline-offset-4">
                  Általános Szerződési Feltételek (ÁSZF)
                </Link>
              </li>
              <li>
                <Link to="/adatkezelesi-tajekoztato" className="text-foreground hover:text-accent transition-colors underline underline-offset-4">
                  Adatkezelési tájékoztató
                </Link>
              </li>
              <li>
                <Link to="/cookie-tajekoztato" className="text-foreground hover:text-accent transition-colors underline underline-offset-4">
                  Süti tájékoztató
                </Link>
              </li>
              <li>
                <Link to="/fogyasztobarat" className="text-foreground hover:text-accent transition-colors underline underline-offset-4">
                  Képes fogyasztói tájékoztató
                </Link>
              </li>
            </ul>
          </div>

        </div>

        {/* Nyitvatartás Section */}
        <div className="border-t border-border/40 pt-16 mb-16 mx-auto">
          <h4 className="text-xs uppercase tracking-widest font-bold mb-8 text-accent text-center">
            Nyitvatartás
          </h4>
          <ul className="space-y-4 text-sm font-light text-muted-foreground max-w-sm mx-auto">
            <li className="flex justify-between items-center border-b border-border/20 pb-3">
              <div className="flex items-center gap-3">
                <Clock className="w-4 h-4 text-accent" />
                <span className="text-foreground tracking-wide">Hétfő – Péntek</span>
              </div>
              <span className="text-foreground font-medium tracking-wider">11:00 – 17:00</span>
            </li>
            <li className="flex justify-between items-center border-b border-border/20 pb-3">
              <div className="flex items-center gap-3">
                <Clock className="w-4 h-4 text-accent" />
                <span className="text-foreground tracking-wide">Szombat – Vasárnap</span>
              </div>
              <span className="text-muted-foreground tracking-wider italic">Zárva</span>
            </li>
          </ul>
          <p className="mt-8 text-center text-[10px] uppercase tracking-widest font-medium text-foreground opacity-80">
            Rendelésfelvétel kiszállításra reggel 8:00 órától!
          </p>
        </div>
        
        <div className="border-t border-border/40 pt-8 flex justify-center items-center text-xs font-light text-muted-foreground">
          <p className="tracking-widest uppercase">&copy; {new Date().getFullYear()} A KONYHÁD Kft. Minden jog fenntartva.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
